// extracted by mini-css-extract-plugin
export default {"paginator":"Paginator_paginator__tkxPx","pageNumber":"Paginator_pageNumber__dsBoN","selectedPage":"Paginator_selectedPage__CB3Pq"};